export const LABELS = {
    personaDoc: "Documento",
    licArmas: "Licencia de armas",
    licCaza: "Licencia de caza",
    seguro: "Seguro",
};
